// ©2024 Austin App House. All rights reserved.
import React from 'react';
import { Field, Form, reduxForm } from 'redux-form';
import { withRouter } from 'react-router-dom';
import InputField from './customFields/InputField';
import SelectContractor from '../SelectContractor';
import { compact } from 'lodash';
import RowActions from '../../dashboard/RowActions';

const dashboardSelectClassNames = {
  control: ({ isFocused }) => (
    `dashboard-select-control${isFocused ? ' dashboard-select-control--is-focused' : ''}`
  ),
  menu: () => 'dashboard-select-menu',
  menuList: () => 'dashboard-select-menu-list',
  option: ({ isFocused, isSelected }) => (
    `dashboard-select-option${isFocused ? ' dashboard-select-option--focused' : ''}${isSelected ? ' dashboard-select-option--selected' : ''}`
  ),
  singleValue: () => 'dashboard-select-single-value',
  placeholder: () => 'dashboard-select-placeholder',
  valueContainer: () => 'dashboard-select-value-container',
  input: () => 'dashboard-select-input',
};

let AddOrEditGroupsReduxForm = ({
  handleSubmit,
  closeModal,
  handleSelectContractor,
  removeContractor,
  selectedContractors,
  setAllContractors,
  submitting,
}) => (
  <Form onSubmit={handleSubmit}>
    <div className="popup_body">
      <div className="field_col">
        <label className="field_name" htmlFor="groupName">
          Group name
        </label>
        <Field
          id="groupName"
          name="name"
          component={InputField}
          type="text"
          placeholder="Type here..."
          maxLength={50}
          inputClassName="dashboard-input"
          paddingBottomClassName=""
        />
      </div>

      <div className="field_col">
        <label className="field_name" htmlFor="groupType">
          Group type
        </label>
        <div className="dashboard-select-wrap">
          <SelectContractor
            selectedContractor={null}
            getSelectedContractor={handleSelectContractor}
            setFetchedContractors={setAllContractors}
            placeholder="Type to find contractors!"
            dashboardStyle
            selectClassNames={dashboardSelectClassNames}
          />
        </div>
      </div>

      {compact(selectedContractors).length > 0 ? (
        <div className="dashboard-modal-members">
          <table className="subpage-table">
            <tbody>
              {compact(selectedContractors).map((contractor) => (
                <tr key={contractor?.value?._id || contractor?.value?.userId}>
                  <td>
                    <span className="row-name">{contractor?.label}</span>
                  </td>
                  <td>
                    <RowActions
                      alignEnd
                      showEdit={false}
                      onDelete={(e) => {
                        e.preventDefault();
                        removeContractor(contractor?.value?.userId);
                      }}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : null}
    </div>

    <div className="popup_footer">
      <button
        className="dashboard-btn dashboard-btn--secondary"
        aria-label="cancel"
        type="button"
        onClick={closeModal}
      >
        Cancel
      </button>
      <button
        className="dashboard-btn dashboard-btn--primary"
        aria-label="save"
        type="submit"
        disabled={submitting}
      >
        Save
      </button>
    </div>
  </Form>
);

AddOrEditGroupsReduxForm = reduxForm({
  form: 'addOrEditGroupsReduxForm',
  enableReinitialize: true,
})(AddOrEditGroupsReduxForm);

export default withRouter(AddOrEditGroupsReduxForm);
